import React from "react";
import "./PlateWell.scss";

interface PlateWellProps {
  id: string;
  status: "empty" | "filled";
  type: "blank" | "sample" | "none";
  onClick: () => void;
}

const PlateWell = ({ id, status, type, onClick }: PlateWellProps) => {
  return (
    <div
      data-title={id}
      className={`plate-well ${status} ${type}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
    >
      {(type === "blank" || type === "sample") && (
        <div className="well-inner" />
      )}
    </div>
  );
};

export default PlateWell;
